module.exports = __webpack_public_path__ + "static/media/engage-greeting-splash-screen-bg.6607caf3.svg";